import { events } from "../../../exports/event-q-bus";
import type { OrientationTypes } from "./orientation.js";
import type { QBusEventMap } from "../../event-q-bus/index.js";

/**
 *
 *
 *
 *
 */
export type TouchableDetectedEventData = {
  /**
 *
 */
  ontouchstart: boolean;
  /**
 *
 */
  documentTouch: boolean;
  /**
 *
 */
  maxTouchPoints: boolean;
};

/**
 *
 *
 *
 */
export type HybridDetectedEventData = {
  /**
 *
 */
  fromStorage?: boolean;
  /**
 *
 */
  fromDetector?: boolean;
};

/**
 *
 */
export type DeviceEvents = QBusEventMap<{
  /**
 *
 */
  "assets.device.touchable.detected": [data: TouchableDetectedEventData];
  /**
 *
 */
  "assets.device.hybrid.detected": [data: HybridDetectedEventData];
  /**
 *
 */
  "assets.device.orientation.changed": [activeOrientation: OrientationTypes];
}>;

export const EVENTS = [
  "assets.device.hybrid.detected",
  "assets.device.touchable.detected",
  "assets.device.orientation.changed",
] as const satisfies (keyof DeviceEvents)[];

export const deviceEvents = events<DeviceEvents>();
